import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ImageWidgetUploadInput from "../../../../../../parts/inputs/image-widget-upload";

const EditPlaylistInfo = ({ playlist }) => {
  const { t } = useTranslation("coaching-portal");
  const { name, description, id: _id, videos, image } = playlist;
  const [currentPlaylist, setCurrentPlaylist] = useState({
    name,
    description,
    _id,
    videos,
    image,
  });
  /**
   * Validate if the playlist's form is valid
   * @returns
   */
  const validationPlaylistSubmit = () => {
    if (
      Object.keys(currentPlaylist)?.length > 0 &&
      currentPlaylist.description?.length > 0 &&
      currentPlaylist.name?.length > 0
    ) {
      return true;
    }
    return false;
  };
  /**
   * Assign the value of the create playlist's state
   * @param {*} param0
   */
  const handleInputPlayListChange = ({ target }) => {
    setCurrentPlaylist({
      ...currentPlaylist,
      [target.name]: target.value,
    });
  };

  const textAreaRef = useRef(null);
  const [textAreaHeight, setTextAreaHeight] = useState(50);

  useEffect(() => {
    if (textAreaRef) {
      setTextAreaHeight(
        textAreaRef.current.scrollHeight ? textAreaRef.current.scrollHeight : 50
      );
    }
  }, [textAreaRef]);

  return (
    <form
      encType="multipart/form-data"
      method="POST"
      data-noreset
      action={`/actions/video-playlist/save/${currentPlaylist._id}`}
      className="edit-playlist-info"
    >
      <ImageWidgetUploadInput
        name="image"
        prefix={t("widgets.editVideoPlaylist.prefix")}
        defaultValue={currentPlaylist.image}
        backgroundedit={`${currentPlaylist.image.s3Path}`}
        hasImage={currentPlaylist.image?.s3Path ? true : false}
      />
      <label htmlFor="name">{t("widgets.editPlaylistInfo.videoPlaylistName")}</label>
      <input
        name="name"
        className="input-videoplaylist-name text-input"
        placeholder={t("widgets.editVideoPlaylist.enterName")}
        value={currentPlaylist.name}
        onChange={handleInputPlayListChange}
      />
      <label htmlFor="description">{t("widgets.editVideoPlaylist.description")}</label>
      <textarea
        name="description"
        className="textarea-input"
        value={currentPlaylist.description}
        onChange={handleInputPlayListChange}
        placeholder={t("widgets.editVideoPlaylist.enterDescription")}
        ref={textAreaRef}
        style={{ height: textAreaHeight }}
      />
      <input
        name="widget"
        style={{ display: "none" }}
        defaultValue={currentPlaylist.widget}
      />
      <button
        type="submit"
        data-button-type="primary"
        disabled={!validationPlaylistSubmit()}
      >
        {t("widgets.editVideoPlaylist.save")}
      </button>
    </form>
  );
};

export default EditPlaylistInfo;
